import {FilesItem} from 'quickstart/components/content/FilesItem'
import {Stack} from 'quickstart/components/layout/Stack'
import * as R from 'rambdax'
import {forwardRef} from 'react'
import {magicSort, sortBySortField} from 'tizra'

const itemLabel = item => item.props.DisplayName || item.name

export const FilesList = forwardRef(
  ({iconsEnabled, iconSize, items: unsortedItems, ...rest}, ref) => {
    const items = R.pipe(magicSort(itemLabel), sortBySortField)(unsortedItems)

    if (iconSize === 'auto') {
      iconSize = items.length < 4 ? 'medium' : 'small'
    }

    return (
      <Stack spacing="0" {...rest} ref={ref}>
        {items.map((item, i) => (
          <FilesItem
            key={i}
            item={item}
            label={itemLabel(item)}
            iconEnabled={iconsEnabled}
            iconSize={iconSize}
          />
        ))}
      </Stack>
    )
  },
)
